import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { TriangleAlert } from "lucide-react";
import { ReactNode } from "react";
import { NavLink, useLocation } from "react-router-dom";

export function DeprecatedViewBanner({ children }: { children: ReactNode }) {
    return (
        <Alert variant="warning">
            <TriangleAlert className="h-4 w-4" />
            <AlertTitle>Cette page va disparaître</AlertTitle>
            <AlertDescription>{children}</AlertDescription>
        </Alert>
    );
}

// Legacy apprenticeship surfaces with no page of their own to edit: the offers are served by the
// generic sf_like screens, and the companies list by a route the banner has no context to enrich.
// Screens that can point to the exact CRM record render DeprecatedViewBanner themselves instead.
const DEPRECATED_ROUTES = [
    {
        pattern: /^\/alternance\/entreprises\/?$/,
        message: "Ne l'utilisez plus pour gérer les entreprises.",
        to: "/accounts",
        label: "Passez par les entreprises du CRM"
    },
    {
        pattern: /^\/apprenticeship-offers(\/|$)/,
        message: "Ne l'utilisez plus pour gérer les offres.",
        to: "/opportunities",
        label: "Passez par les opportunités du CRM"
    }
];

export function DeprecatedRouteBanner() {
    const { pathname } = useLocation();
    const route = DEPRECATED_ROUTES.find(r => r.pattern.test(pathname));
    if (!route) return null;

    return (
        <div className="mb-4">
            <DeprecatedViewBanner>
                {route.message}{" "}
                <NavLink to={route.to} className="font-medium underline">
                    {route.label}
                </NavLink>
            </DeprecatedViewBanner>
        </div>
    );
}
